import React from "react"
import AniLink from "gatsby-plugin-transition-link/AniLink"
import { StaticQuery, graphql } from "gatsby"
import { globalHistory } from "@reach/router"

function Tiles({ data }) {
  const path = globalHistory.location.pathname
  var pathPattern = path.match(new RegExp("(?:/[^/]*){0,2}"))

  return (
    <div className="tiles">
      {data.allMarkdownRemark.edges.map(({ node }) => {
        var regnode = node.fields.slug
        if (regnode.match(pathPattern))
          return (
            <AniLink
              fade
              duration={0.25}
              key={node.id}
              to={node.fields.slug}
              activeClassName="active"
              className="card"
            >
              <h3>{node.frontmatter.title}</h3>
            </AniLink>
          )
        else return null
      })}
    </div>
  )
}

const postList = () => (
  <StaticQuery
    query={graphql`
      {
        allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
          totalCount
          edges {
            node {
              id
              fields {
                slug
              }
              frontmatter {
                title
              }
            }
          }
        }
      }
    `}
    render={data => <Tiles data={data} />}
  />
)

export default postList;